module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Weather/Moon-909a604d2a82f1844a6a6d150b1cb5e5.svg";